import styled from 'styled-components';
import InfoBox from 'src/design/components/infoBox/InfoBox';
import { gridUnit } from 'src/design/styleguide/common/measurements';
import { getVictorianPublicHolidayNotice } from 'src/utils/victorianPublicHoliday';

const NoticeOuter = styled.div`
  padding: ${gridUnit * 4}px ${gridUnit * 4}px;
`;

const NoticeInner = styled.div`
  margin: 0 auto;
  max-width: 1200px;
`;

const PublicHolidayNotice = () => {
  const holidayNotice = getVictorianPublicHolidayNotice();

  if (!holidayNotice) {
    return null;
  }

  return (
    <NoticeOuter>
      <NoticeInner>
        <InfoBox testRef="public-holiday-notice">
          Support unavailable during public holidays. Resumes{' '}
          {holidayNotice.resumeDateText}. Platform remains fully operational.
        </InfoBox>
      </NoticeInner>
    </NoticeOuter>
  );
};

export default PublicHolidayNotice;
